import {
  Button,
  ConfigProvider,
  Form,
  Image,
  Input,
  Modal,
  Table,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "wouter";
import { LoginDealerData } from "../../../redux/actions/authActions";
import Alertify from "../../../services/alertify";
import { setDeafultDealerCode } from "../../../redux/reducers/authSlice";

const { Title } = Typography;

const UserLogin = () => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [, setLocation] = useLocation();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dealerCodes, setDealerCodes] = useState([]);
  const handleSubmit = (values) => {
    const data = {
      email_or_mobile: values.email,
      password: values.password,
    };
    // console.log(data);

    dispatch(LoginDealerData(data))
      .then((response) => {
        console.log("response is:", response);
        if (response.meta.requestStatus === "fulfilled") {
          const dealerCodes = response.payload?.data?.user?.dealer_details;
          if (dealerCodes.length > 1) {
            setDealerCodes(dealerCodes);
            setIsModalOpen(true);
          } else {
            const firstDealerCode =
              response.payload?.data?.user?.dealer_details[0]?.dealer_id;
            console.log(
              "firstDealerCode",
              response.payload?.data?.user?.dealer_details[0]?.dealer_id
            );
            dispatch(setDeafultDealerCode(firstDealerCode));
            setLocation("/cart");
          }
        }
      })
      .catch((error) => {
        Alertify.error("Login failed: " + error.message);
      });
  };
  useEffect(() => {
    document.title = "Dealer Login: ALP Shop";
  }, []);
  const DealerCodeColumns = [
    {
      title: "Dealer Code",
      dataIndex: "dealer_id",
      key: "dealer_id",
    },
    {
      title: "Brand",
      dataIndex: "brand",
      key: "brand",
    },
    {
      title: "Billing Address",
      dataIndex: "",
      key: "address",
      render: (text, record) => (
        <div>
          {record?.address}
          {record?.address2}
          {record?.city}
          {record?.state}
          {record?.pincode}
        </div>
      ),
    },
  ];
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      // console.log(
      //   `selectedRowKeys: ${selectedRowKeys}`,
      //   "selectedRows: ",
      //   selectedRows
      // );
      dispatch(setDeafultDealerCode(selectedRowKeys[0]));
      setIsModalOpen(false);
      setLocation("/cart");
    },
  };
  return (
    <ConfigProvider
      theme={{
        components: {
          Typography: {
            titleMarginTop: 0,
            /* here is your component tokens */
          },
          Modal: {
            borderRadiusLG: 8,
          },
        },
      }}
    >
      <div className="h-screen flex items-center justify-center gap-4 bg-gradient-to-r from-[#0474B8] to-[#034B78]">
        <div className="w-1/2 h-full p-16 max-sm:hidden">
          <img
            className="max-sm:hidden min-h-full object-cover rounded-2xl"
            src="/assets/login/login_truck.jpg"
            alt="Login Banner"
          />
        </div>
        <div className="sm:w-1/2 p-16">
          <Image width={100} src="/assets/alp.svg" preview={false} />
          <Title level={2} className="2xl:py-4">
            <span className="text-white">Dealer Management System</span>
          </Title>
          <Form
            layout="vertical"
            className="shadow-2xl p-6 2xl:p-10 rounded-lg w-full bg-white"
            size={"large"}
            onFinish={handleSubmit}
          >
            <Form.Item label="Email Address" name="email">
              <Input type="email" placeholder="Enter Email" />
            </Form.Item>
            <Form.Item label="Password" name="password">
              <Input.Password
                placeholder="Enter Password"
                visibilityToggle={{
                  visible: passwordVisible,
                  onVisibleChange: setPasswordVisible,
                }}
              />
            </Form.Item>
            <div className="flex itemx-center justify-between">
              <Form.Item>
                <Button
                  className="bg-[#C21616] w-full text-white rounded-lg"
                  htmlType="submit"
                >
                  SUBMIT
                </Button>
              </Form.Item>
              <div className="text-right text-[#0474b8]">
                <Link to="/forgot-password">Forgot password</Link>
              </div>
            </div>
          </Form>
        </div>
      </div>
      <Modal
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={false}
        width={800}
        centered
      >
        <div>
          <div className="flex items-center gap-16">
            <Title level={3}>Select Dealer Code</Title>
          </div>
          <Table
            rowKey="dealer_id"
            className="max-sm:overflow-x-scroll max-w-full"
            size="small"
            pagination={false}
            rowSelection={{ type: "radio", ...rowSelection }}
            columns={DealerCodeColumns}
            dataSource={dealerCodes}
          />
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default UserLogin;
